module.exports = __webpack_public_path__ + "static/img/icon-coupon-reduce.3b094b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-coupon-reduce.png
// module id = 113
// module chunks = 7